import { ArticleCuttingParams } from "../../models/articleModel";
import ArticleService from "../services/ArticleService";
import { setDBLoadingState } from "../slices/db";
import store from "../store";
import { formatDataForDB } from "./articleCuttingParamTroDB";
import { db } from "./db";

export const fillArticleCuttingParamStdDB = () => {
    return db.articlesCuttingParamsStd.count(async function (count: number) {
        if (count > 0) {
            //console.log("ArticleCuttingParamsStd Already populated");
        } else {
            //console.log("ArticleCuttingParamsStd Database is empty. Populating from ajax call...");
            store.dispatch(setDBLoadingState(true));
            await ArticleService.getArticlesCuttingParamsStd()
                .then((data) => {
                    //console.log("Got ajax response. We'll now add the objects.");
                    //console.log("Calling bulkAdd() to insert objects...");
                    if (data) {
                        let formattedData: ArticleCuttingParams[] = formatDataForDB(data)
                        return db.articlesCuttingParamsStd.bulkAdd(formattedData);
                    }
                })
                .then(() => {
                    //console.log("Done populating.");
                    return db.timestamps.add({ name: "articlesCuttingParamsStd", timestamp: String(new Date()) })
                }).catch(err => console.log(err))

        }
    })
}

export const deleteArticleCuttingParamStdDB = () => {
    return db.articlesCuttingParamsStd.clear().then(() => {
        //console.log("Database successfully cleared");
    }).catch((err) => {
        //console.error("Could not clear database");
    })
}

export const updateArticleCuttingParamStdDB = async () => {
    await ArticleService.getArticlesCuttingParamsStd()
        .then(async (data) => {
            await deleteArticleCuttingParamStdDB().then(() => {
                let formattedData: ArticleCuttingParams[] = formatDataForDB(data);
                //@ts-ignore
                return db.articlesCuttingParamsStd.bulkPut(formattedData);
            })
        })
        .then(() => {
            return db.timestamps.put({ name: "articlesCuttingParamsStd", timestamp: String(new Date()) })
            //console.log("Done refilling.");
        })
        .catch(err => console.log(err));
}